import project from '@/project'
import axios from 'axios'
import store from '../store'

export default () => {
  const instance = axios.create({
    baseURL: project.config.web.api,
  })

  if (store.state.auth.auth.access_token) {
    instance.defaults.headers.common['Authorization'] = store.state.auth.auth.access_token

    // # for test on local only
    // instance.defaults.headers.common['shop_id'] = ''
    // instance.defaults.headers.common['user_id'] = ''
  }

  if (store.state.auth.auth.refresh_token) {
    instance.defaults.headers.common['X-Refresh-Token'] = store.state.auth.auth.refresh_token
  }

  return instance
}



// WEBPACK FOOTER //
// ./src/api/Api.js